import React, { Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import classNames from "classnames";
import { FormControlLabel, Checkbox, Select, TextField, MenuItem, Grid } from "@material-ui/core";
import { connect } from 'react-redux';
import Simplert from 'react-simplert';
import validator from 'validator';
import { getOrderSummary } from '../../../../../store/actions';
import history from '../../../../../../history';

import { withRouter } from "react-router-dom";
import $ from 'jquery';
import { compose } from "redux";
import {
    container,
    title,
    main,
    mainRaised,
    mrAuto,
    whiteColor,
    mlAuto,
} from "../../../../../../assets/jss/material-kit-pro-react.js";

import { isEmpty } from "lodash";
import { formatNumberWithDecimals } from '../../../../../utils/formatNumber.js';

const useStyles = theme => ({
    main,
    mainRaised,
    mrAuto,
    mlAuto,
    title,
    container: {
        ...container,
        zIndex: 2,

    },
    title1: {
        ...title,
        "&, & + h4": {
            color: whiteColor,
        },
    },
    textCenter: {
        textAlign: "center",
    },
    block: {
        color: "inherit",
        padding: "0.9375rem",
        fontWeight: "500",
        fontSize: "12px",
        textTransform: "uppercase",
        borderRadius: "3px",
        textDecoration: "none",
        position: "relative",
        display: "block",
    },
    inlineBlock: {
        display: "inline-block",
        padding: "0px",
        width: "auto",
    },
    list: {
        marginBottom: "0",
        padding: "0",
        marginTop: "0",
    },
    right: {
        padding: "15px 0",
        margin: "0",
        float: "right!important",
        display: "block",
    },

    left: {
        padding: "15px 0",
        float: "left!important",
        display: "block",
        margin: 0
    },
    icon: {
        width: "18px",
        height: "18px",
        top: "3px",
        position: "relative",
    },
    boxArea: {
        textAlign: "center!important",
        padding: "0px",
        width: "100%"
    },


    vicon: {
        fill: "green",
    },
    text: {
        fill: "white",
    },

    iconHolder: {
        padding: "35px 0px 0px 0px",
    },
});





class OrderPriceBreakDown extends Component {

    componentDidMount() {

        let date = this.props.reqDelDate;
        const splited = date.split('-');
        const swaped = [splited[2] + "/", splited[1] + "/", splited[0]];
        this.setState({ reqDisplayDate: swaped });

        if (this.props.errorOccurredSummaryPage) {
            /*   history.push('/error-page');*/
            this.props.history.push("/error-page");
        }
    }



    state = {
        reqDisplayDate: ''
    }

    //async GetSummaryOrder() {
    //    try {



    //        for (let i = 0; i < this.props.orderSelectedProductsList.length; i++) {

    //            this.props.orderSelectedProductsList[i].packs = parseInt(this.props.orderSelectedProductsList[i].packs);
    //            this.props.orderSelectedProductsList[i].totalWeight = parseFloat(this.props.orderSelectedProductsList[i].totalWeight);
    //        }

    //        await this.props.getOrderSummary(
    //            this.props.user.customerId,
    //            this.props.branchInfo.id,
    //            this.props.deliverySiteInfo.id,
    //            this.props.totalWeight,
    //            this.props.surchargeNeeded,
    //            this.props.surchargePercentage,
    //            this.props.orderSelectedProductsList
    //        )

    //        let date = this.props.reqDelDate;
    //        const splited = date.split('-');
    //        const swaped = [splited[2] + "/", splited[1] + "/", splited[0]];
    //        this.setState({ reqDisplayDate: swaped });

    //        this.props.handleLangChange();

    //    } catch (e) {

    //    }

    //}


    render() {

        let discount1Label = "";
        let discount1Value = "";

        let discount2Label = "";
        let discount2Value = "";

        let discount3Label = "";
        let discount3Value = "";

       if (this.props.orderSummaryResult.usedAlthamPricing && this.props.orderSummaryResult.loading_Discount_Percent > 0) {
            discount1Label = "Discount For Quantity Ordered: ";
            discount1Value = this.props.orderSummaryResult.loading_Discount_Percent + '%';
        }
        else if (this.props.orderSummaryResult.loading_Discount > 0 && this.props.orderSummaryResult.loading_Discount_Enabled) {
            discount1Label = "Discount For Weight Ordered: ";
            discount1Value = this.props.orderSummaryResult.loading_Discount + '%';
        }
        else if (this.props.orderSummaryResult.collection_Discount > 0 && this.props.orderSummaryResult.collection_Discount_Enabled) {
            discount1Label = "Discount For Collection:";
            discount1Value = this.props.orderSummaryResult.collection_Discount + '%';
        }
        else {
            discount1Label = "";
            discount1Value = "";
        }


        if (this.props.orderSummaryResult.easi_Order_Discount > 0 && this.props.orderSummaryResult.easi_Order_Discount_Enabled) {
            discount2Label = "Discount for Ordering Online: ";
            discount2Value = "1%";
        }
        else {
            discount2Label = "";
            discount2Value = "";
        }


        if (this.props.orderSummaryResult.realex_Discount > 0 && this.props.orderSummaryResult.realex_Discount_Enabled) {
            discount3Label = "Discount for Paying Online: ";
            discount3Value = "1%";
        }
        else {
            discount3Label = "";
            discount3Value = "";
        }


        let totalPriceIncDelLabel = "";
        let totalPriceIncDelValue = "";

        if (this.props.orderSummaryResult.total_Price_EX_VAT_Plus_Delivery !== this.props.orderSummaryResult.total_Price_EX_Vat) {

            totalPriceIncDelLabel = "Price Inc Delivery Charge: ";
            totalPriceIncDelValue = "£" + this.props.orderSummaryResult.total_Price_EX_VAT_Plus_Delivery.toFixed(2);
        }
        else {
            totalPriceIncDelLabel = "";
            totalPriceIncDelValue = "";
        }



        let priceBreakdownDetails = "";

        if (!isEmpty(this.props.orderSummaryResult)) {

            if (this.props.orderSummaryResult.total_Discount > 0 || this.props.orderSummaryResult.total_Discount_Percentage > 0) {

                priceBreakdownDetails = <div
                    style={{
                        padding: '5px'
                    }}
                >
                    <Grid container spacing={4} >
                        <Grid item xs={12} sm={6}>
                            <Grid container spacing={0}>

                                {!isEmpty(discount1Value) ?
                                    <><Grid item xs={6} sm={6}>
                                        <h4>{discount1Label}</h4>
                                    </Grid>
                                        <Grid item xs={6} sm={6}>
                                            <h4><b>{discount1Value}</b></h4>
                                        </Grid></>
                                    :
                                    null
                                }

                                {!isEmpty(discount2Value) ?
                                    <><Grid item xs={6} sm={6}>
                                        <h4>{discount2Label}</h4>
                                    </Grid>
                                        <Grid item xs={6} sm={6}>
                                            <h4><b>{discount2Value}</b></h4>
                                        </Grid></>
                                    :
                                    null}

                                {!isEmpty(discount3Value) ?
                                    <><Grid item xs={6} sm={6}>
                                        <h4>{discount3Label}</h4>
                                    </Grid>
                                        <Grid item xs={6} sm={6}>
                                            <h4><b>{discount3Value}</b></h4>
                                        </Grid></>
                                    : null}

                                <Grid item xs={6} sm={6}>
                                    <h4 >Total Discount:</h4>
                                </Grid>
                                <Grid item xs={6} sm={6}>
                                    <h4>
                                        <b>
                                            {this.props.orderSummaryResult.usedAlthamPricing
                                                ? `${this.props.orderSummaryResult.total_Discount_Percentage?.toFixed(2)}%`
                                                : `${this.props.orderSummaryResult.total_Discount}%`}
                                        </b>
                                    </h4>
                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Grid container spacing={0}>

                                <Grid item xs={6} sm={6}>
                                    <h4 >Price (Ex VAT): </h4>
                                </Grid>
                                <Grid item xs={6} sm={6} style={{ paddingInline: '10px' }}>
                                    <h4 ><b> £{this.props.orderSummaryResult.original_Total_price?.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} </b> </h4>
                                </Grid>


                                {this.props.surchargeNeeded ?
                                    <><Grid item xs={6} sm={6}>
                                        <h4>Price Ex Vat (Discount and {this.props.surchargePercentage}% Surcharge Applied):</h4>
                                    </Grid><Grid item xs={6} sm={6} style={{ paddingInline: '10px' }}>
                                            <h4><b> £{this.props.orderSummaryResult.total_Price_EX_Vat.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} </b></h4>
                                        </Grid></>

                                    :
                                    <><Grid item xs={6} sm={6}>
                                        <h4>{this.props.orderSummaryResult.priceDiscountLabel}</h4>
                                    </Grid><Grid item xs={6} sm={6} style={{ paddingInline: '10px' }}>
                                            <h4><b> £{this.props.orderSummaryResult.total_Price_EX_Vat.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} </b></h4>
                                        </Grid></>
                                }



                                {!isEmpty(totalPriceIncDelValue) ?
                                    <><Grid item xs={6} sm={6}>
                                        <h4>{totalPriceIncDelLabel}</h4>
                                    </Grid>
                                        <Grid item xs={6} sm={6} style={{ paddingInline: '10px' }}>
                                            <h4><b>{totalPriceIncDelValue} </b></h4>
                                        </Grid></>

                                    : null}

                                <Grid item xs={6} sm={6}>
                                    <h4 >VAT: </h4>
                                </Grid>
                                <Grid item xs={6} sm={6} style={{ paddingInline: '10px' }}>
                                    <h4 ><b>{this.props.orderSummaryResult.vat}% </b></h4>
                                </Grid>


                                <Grid item xs={6} sm={6}>
                                    <h4 >VAT Amount: </h4>
                                </Grid>
                                <Grid item xs={6} sm={6} style={{ paddingInline: '10px' }}>
                                    <h4 ><b> £{this.props.orderSummaryResult.vaT_Amount.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} </b> </h4>
                                </Grid>



                                <Grid item xs={6} sm={6}>
                                    <h4 >Price Inc VAT:   </h4>
                                </Grid>
                                <Grid item xs={6} sm={6} style={{ paddingInline: '10px' }}>
                                    <h4 > <b> £{this.props.orderSummaryResult.total_Price_Inc_VAT.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} </b> </h4>
                                </Grid>

                            </Grid>
                        </Grid>

                    </Grid>

                </div >



            }
            else {

                if (!isEmpty(this.props.orderSummaryResult)) {

                    priceBreakdownDetails = <div style={{
                        padding: '5px'
                    }}>
                        <Grid container spacing={4} >

                            <Grid item xs={12} sm={6}>
                                <Grid container spacing={0}>




                                    {this.props.surchargeNeeded ?
                                        <><Grid item xs={6} sm={6}>
                                            <h4>Price Ex Vat ({this.props.surchargePercentage}% Surcharge Applied):</h4>
                                        </Grid><Grid item xs={6} sm={6} style={{ paddingInline: '10px' }}>
                                                <h4><b> £{this.props.orderSummaryResult.total_Price_EX_Vat.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} </b></h4>
                                            </Grid></>

                                        :
                                        <>
                                            <Grid item xs={6} sm={6}>
                                                <h4 >Price (Ex VAT): </h4>
                                            </Grid>
                                            <Grid item xs={6} sm={6} style={{ paddingInline: '10px' }}>
                                                <h4 ><b> £{this.props.orderSummaryResult.original_Total_price?.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} </b> </h4>
                                            </Grid></>
                                    }

                                    {!isEmpty(totalPriceIncDelValue) ?
                                        <><Grid item xs={6} sm={6}>
                                            <h4>{totalPriceIncDelLabel}</h4>
                                        </Grid>
                                            <Grid item xs={6} sm={6} style={{ paddingInline: '10px' }}>
                                                <h4><b>{totalPriceIncDelValue} </b></h4>
                                            </Grid></>
                                        : null}

                                    <Grid item xs={6} sm={6}>
                                        <h4 >VAT: </h4>
                                    </Grid>
                                    <Grid item xs={6} sm={6} style={{ paddingInline: '10px' }}>
                                        <h4 ><b>{this.props.orderSummaryResult.vat} % </b></h4>
                                    </Grid>


                                    <Grid item xs={6} sm={6}>
                                        <h4 >VAT Amount:  </h4>
                                    </Grid>
                                    <Grid item xs={6} sm={6} style={{ paddingInline: '10px' }}>
                                        <h4 ><b> £{this.props.orderSummaryResult.vaT_Amount.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} </b> </h4>
                                    </Grid>


                                    <Grid item xs={6} sm={6}>
                                        <h4 >Price Inc VAT:  </h4>
                                    </Grid>
                                    <Grid item xs={6} sm={6} style={{ paddingInline: '10px' }}>
                                        <h4 ><b> £{this.props.orderSummaryResult.total_Price_Inc_VAT.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} </b> </h4>
                                    </Grid>

                                </Grid>
                            </Grid>

                        </Grid>

                    </div>
                }
            }

        }


        const { classes } = this.props;

        return (

            <div style={{ padding: "10px" }}>
                <h3 style={{ borderBottom: "2px dashed grey" }}>Order Summary Details</h3>

                <GridContainer style={{ padding: "5px" }}>

                    {!isEmpty(this.props.cusOrderNumber) ?
                        <>
                            <GridItem xs={6} sm={3} md={3}>
                                <h4 >Customer Order Number: </h4>
                            </GridItem>
                            <GridItem xs={6} sm={3} md={3}>
                                <h4> <b> {this.props.cusOrderNumber} </b> </h4>
                            </GridItem> </> :
                        null
                    }


                    {!isEmpty(this.props.branchInfo) ?
                        <>
                            <GridItem xs={6} sm={3} md={3}>
                                <h4 >Branch: </h4>
                            </GridItem>
                            <GridItem xs={6} sm={3} md={3}>
                                <h4> <b> {this.props.branchInfo.displayText} </b> </h4>
                            </GridItem> </> :
                        null
                    }


                    {!isEmpty(this.props.deliverySiteInfo) ?
                        <>
                            <GridItem xs={6} sm={3} md={3}>
                                <h4 >Delivery Site: </h4>
                            </GridItem>
                            <GridItem xs={6} sm={3} md={3}>
                                <h4> <b> {this.props.deliverySiteInfo.displayText} </b> </h4>
                            </GridItem> </> :
                        null
                    }

                    {!isEmpty(this.props.reqDelDate) ?
                        <>
                            <GridItem xs={6} sm={3} md={3}>
                                <h4 >Requested Delivery Date: </h4>
                            </GridItem>
                            <GridItem xs={6} sm={3} md={3}>
                                <h4> <b> {this.state.reqDisplayDate} </b> </h4>
                            </GridItem> </> :
                        null
                    }


                    {!isEmpty(this.props.totalWeight) ?
                        <>
                            <GridItem xs={6} sm={3} md={3}>
                                <h4 >Total Weights (Tonnes): </h4>
                            </GridItem>
                            <GridItem xs={6} sm={3} md={3}>
                                <h4> <b> {formatNumberWithDecimals(this.props.totalWeight)} </b> </h4>
                            </GridItem> </> :
                        null
                    }


                    {!isEmpty(this.props.lorryLoads) ?
                        <>
                            <GridItem xs={6} sm={3} md={3}>
                                <h4 >Larry Loads: </h4>
                            </GridItem>
                            <GridItem xs={6} sm={3} md={3}>
                                <h4> <b> {this.props.lorryLoads} </b> </h4>
                            </GridItem> </> :
                        null
                    }


                    {!isEmpty(this.props.specialInstructions) ?
                        <>
                            <GridItem xs={6} sm={3} md={3}>
                                <h4 >Special Instructions: </h4>
                            </GridItem>
                            <GridItem xs={6} sm={3} md={3}>
                                <h4> <b> {this.props.specialInstructions} </b> </h4>
                            </GridItem> </> :
                        null
                    }

                </GridContainer>





                {/* Price Brekdown */}
                <div>
                    <h3 style={{ borderBottom: "2px dashed grey" }}>Price Breakdown </h3>
                    {priceBreakdownDetails}
                </div>
                {/* Price Brekdown */}




            </div>
        )

    }


}


const mapStateToProps = state => {
    return {
        user: state.userReducer.user,
        orderSummaryResult: state.orderReducer.orderSummaryResult,

        //redux data from previous page
        surchargeNeeded: state.orderReducer.surchargeNeeded,
        surchargePercentage: state.orderReducer.surchargePercentage,
        reqDelDate: state.orderReducer.reqDelDate,
        lorryLoads: state.orderReducer.lorryLoads,
        cusOrderNumber: state.orderReducer.cusOrderNumber,
        specialInstructions: state.orderReducer.specialInstructions,
        selectedDeliverySiteId: state.orderReducer.selectedDeliverySiteId,
        reqDelDate: state.orderReducer.reqDelDate,
        totalWeight: state.orderReducer.totalWeight,
        deliverySiteInfo: state.orderReducer.deliverySiteList == null ? null : state.orderReducer.deliverySiteList.find(item => item.id === parseInt(state.orderReducer.selectedDeliverySiteId)),
        minOrderWeight: state.orderReducer.minOrderWeight,
        maxOrderWeight: state.orderReducer.maxOrderWeight,
        customerSurchargesList: state.orderReducer.customerSurchargesList,
        orderSelectedProductsList: state.orderReducer.orderSummaryProducts,
        branchList: state.orderReducer.branchList,
        branchInfo: state.orderReducer.branchList == null ? null : state.orderReducer.branchList.find(item => item.id === parseInt(state.orderReducer.selectedBranchId)),
        errorOccurredSummaryPage: state.orderReducer.errorOccurredSummaryPage
    };
};

export default compose(withRouter, connect(mapStateToProps, { getOrderSummary }))(withStyles(useStyles)(OrderPriceBreakDown));